/** The login token from /login/email#token=… (see EmailLoginPage), or null. */
const TOKEN_RE = /^[A-Za-z0-9_-]{20,128}$/;

export function emailLoginToken(hash: string): string | null {
  const token = new URLSearchParams(hash.replace(/^#/, "")).get("token") ?? "";
  return TOKEN_RE.test(token) ? token : null;
}
